import React from 'react';

import { dataDeletionEmailSubject, dataDeletionMailTo, publicSupportEmail } from './legalConfig';

export const ExclusaoDados = () => {
    return (
        <div className="max-w-4xl mx-auto p-6 bg-base-100 text-base-content">
            <header className="text-center mb-8">
                <h1 className="text-4xl font-bold text-black">Exclusão de Dados</h1>
                <p className="mt-4">
                    Esta página explica como solicitar a exclusão dos seus dados pessoais
                    tratados pelo SalonFlow.
                </p>
            </header>

            <section className="space-y-6">
                <div className="collapse collapse-plus bg-base-200 rounded-box">
                    <input type="checkbox" defaultChecked />
                    <div className="collapse-title text-lg font-medium">1. Como solicitar a exclusão</div>
                    <div className="collapse-content space-y-3">
                        <p>
                            Envie sua solicitação para{' '}
                            <a href={dataDeletionMailTo} className="text-primary hover:underline">
                                {publicSupportEmail}
                            </a>{' '}
                            com o assunto <span className="font-bold">{dataDeletionEmailSubject}</span>.
                        </p>
                        <p>
                            Se preferir, use o botão abaixo para abrir a solicitação no seu e-mail.
                        </p>
                        <a href={dataDeletionMailTo} className="btn btn-primary">
                            Solicitar exclusão por e-mail
                        </a>
                    </div>
                </div>

                <div className="collapse collapse-plus bg-base-200 rounded-box">
                    <input type="checkbox" />
                    <div className="collapse-title text-lg font-medium">2. Informações que devem ser enviadas</div>
                    <div className="collapse-content">
                        <ul className="list-disc ml-6">
                            <li>Nome completo</li>
                            <li>E-mail cadastrado no app</li>
                            <li>Telefone cadastrado, se houver</li>
                            <li>Nome do estabelecimento relacionado ao atendimento</li>
                            <li>Descrição do pedido de exclusão</li>
                            <li>Se aplicável, identificador usado em integrações como Instagram/Facebook</li>
                        </ul>
                    </div>
                </div>

                <div className="collapse collapse-plus bg-base-200 rounded-box">
                    <input type="checkbox" />
                    <div className="collapse-title text-lg font-medium">3. Validação da solicitação</div>
                    <div className="collapse-content">
                        <p>
                            Para proteger sua privacidade, podemos solicitar informações adicionais
                            para confirmar sua identidade antes de concluir a exclusão.
                        </p>
                    </div>
                </div>

                <div className="collapse collapse-plus bg-base-200 rounded-box">
                    <input type="checkbox" />
                    <div className="collapse-title text-lg font-medium">4. Prazo e tratamento</div>
                    <div className="collapse-content">
                        <p>
                            Após a validação, a solicitação será analisada e processada em prazo
                            razoável. Quando permitido, os dados serão excluídos ou anonimizados.
                        </p>
                    </div>
                </div>

                <div className="collapse collapse-plus bg-base-200 rounded-box">
                    <input type="checkbox" />
                    <div className="collapse-title text-lg font-medium">5. Dados que podem ser mantidos</div>
                    <div className="collapse-content">
                        <p>
                            Alguns registros poderão ser mantidos pelo tempo necessário para cumprir
                            obrigações legais, regulatórias, prevenção a fraudes, segurança ou defesa
                            de direitos.
                        </p>
                    </div>
                </div>

                <div className="collapse collapse-plus bg-base-200 rounded-box">
                    <input type="checkbox" />
                    <div className="collapse-title text-lg font-medium">6. Mais informações</div>
                    <div className="collapse-content">
                        <p>
                            Para detalhes adicionais sobre coleta, uso e retenção de dados, consulte
                            nossa{' '}
                            <a
                                href="/politicaDePrivacidade"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary hover:underline"
                            >
                                Política de Privacidade
                            </a>
                            .
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};
